module.exports = __webpack_public_path__ + "img/arrow-red-down.e6acd0fe.svg";